<template>
  <div
    class="bg-red-100 border border-red-300 text-red-900 px-4 py-3 flex items-start justify-between gap-6"
    role="alert"
  >
    <div class="flex-1">
      <p class="font-semibold">Brak autoryzacji</p>
      <p class="text-sm mt-1">
        {{ message }}
      </p>
    </div>
    <button
      type="button"
      class="text-sm font-medium text-red-800 hover:text-red-600 focus:outline-none"
      @click="$emit('dismiss')"
    >
      Zamknij
    </button>
  </div>
</template>

<script setup>
defineProps({
  message: {
    type: String,
    required: true,
  },
});
</script>





